(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["shoppable-video"] && !Shopify.designMode) return;
  try {
    

const scrollContainer = document.querySelector('.shoppable-video-sec .item-wrapper');
const dots = document.querySelectorAll('.dot');

// Dynamically calculate item size and container styles
const item = scrollContainer.querySelector('.item'); // Replace '.item' with your actual item class
const itemStyle = window.getComputedStyle(item);
const itemWidth = item.offsetWidth;
const gap = parseInt(itemStyle.marginRight) || 0;

const containerStyle = window.getComputedStyle(scrollContainer);
const containerPaddingLeft = parseInt(containerStyle.paddingLeft) || 0;

// Update active dot based on scroll position
scrollContainer.addEventListener('scroll', () => {
  const scrollPosition = scrollContainer.scrollLeft + containerPaddingLeft;
  const activeIndex = Math.round(scrollPosition / (itemWidth + gap));

  dots.forEach((dot, index) => {
    dot.classList.toggle('active', index === activeIndex);
  });
});

// Scroll to item when a dot is clicked
dots.forEach(dot => {
  dot.addEventListener('click', () => {
    const index = parseInt(dot.getAttribute('data-index'));

    // Calculate target scroll position considering padding and gap
    const targetPosition = index * (itemWidth + gap) - containerPaddingLeft;

    scrollContainer.scrollTo({
      left: targetPosition,
      behavior: 'smooth',
    });
  });
});



  

  } catch(e) { console.error(e); }
})();
})();
